import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, message } from 'antd';
import axiosInstance from '../../../axiosInstance';
import { getUserData } from '../../constants';

const userData = getUserData();
const rolePermission = userData && userData?.user ? userData?.user?.role?.role_permission : {};

const Roles = () => {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();
    const [roles, setRoles] = useState([]);
    const [loading, setLoading] = useState(false);

    // Fetch roles from backend
    useEffect(() => {
        // const fetchRoles = async () => {
        //     setLoading(true);
        //     try {
        //         const response = await axiosInstance.get('/all-roles');
        //         // console.log(response.data); // Debugging line
        //         setRoles(response.data.roles || []); // Ensure roles is an array
        //     } catch (error) {
        //         message.error("Failed to load roles.");
        //         // console.error("Error fetching roles:", error);
        //     } finally {
        //         setLoading(false); // Set loading to false in both success and error cases
        //     }
        // };

        const fetchRoles = async () => {
            setLoading(true);
            try {
                const response = await axiosInstance.get('/all-roles');
                
                // Double filtering (backend should handle this, but this is a safety net)
                const filteredRoles = (response.data.roles || []).filter(role => {
                    // Skip if role name is undefined/null
                    if (!role.name) return true;
                    return role.name.toLowerCase() !== 'system owner' || rolePermission.is_system_owner === 1;
                });
                
                setRoles(filteredRoles);
            } catch (error) {
                message.error("Failed to load roles.");
            } finally {
                setLoading(false);
            }
        };

        fetchRoles();
    }, []);

    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);
            const response = await axiosInstance.post('/roles', { name: values.name });
            setRoles([...roles, response.data.role]); // Ensure response contains role
            message.success("Role created successfully");
            setIsModalVisible(false);
            form.resetFields();
        } catch (error) {
            if (error.response && error.response.data.errors) {
                message.error(error.response.data.errors.name[0]);
            } else {
                message.error("Failed to create role");
            }
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        form.resetFields(); // Reset form to prevent issues with null values
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        selections: [
            Table.SELECTION_ALL,
            Table.SELECTION_INVERT,
            Table.SELECTION_NONE,
        ],
    };

    return (
        <div>
            <div style={{ textAlign: 'right', marginBottom: 16 }}>
                <Button type="primary" onClick={showModal}>
                    Add Role
                </Button>
            </div>

            <Table
                rowSelection={rowSelection}
                columns={[{ title: 'Role Name', dataIndex: 'name', key: 'name', width: 200 }]}
                dataSource={roles?.map(role => ({ key: role.id, name: role.name })) || []} // Ensure empty array fallback
                pagination={{ pageSize: 25 }}
                scroll={{ x: 'max-content' }} 
                sticky
                loading={loading}
            />

            <Modal
                title="Add New Role"
                visible={isModalVisible}
                onOk={() => form.submit()}
                onCancel={handleCancel}
                confirmLoading={loading}
                okText="Add"
                cancelText="Cancel"
                destroyOnClose
            >
                <Form form={form} layout="vertical" onFinish={handleOk}>
                    <Form.Item
                        name="name"
                        label="Role Name"
                        rules={[{ required: true, message: 'Please input the role name!' }]}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default Roles;
